import { startsWith } from 'lodash';

function isRouteActive(itemPath, locationPath) {
  return startsWith(locationPath, itemPath);
}

export default isRouteActive;
